import { useState, useRef, useEffect } from 'react';
import { sendMessage } from 'modules/chat/repository';

export function useChat({ context }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
  }, [messages, messagesEndRef]);

  const handleSendMessage = async () => {
    if (!input.trim() || isLoading) return;

    const userMessage = { role: 'user', content: input.trim() };
    const assistantMessage = { role: 'assistant', content: '' };

    setInput('');
    setIsLoading(true);
    setMessages(prev => [...prev, userMessage, assistantMessage]);

    // eslint-disable-next-line consistent-return
    await sendMessage({ messages: [...messages, userMessage], context }, data => {
      if (data === '[DONE]') return setIsLoading(false);
      if (data === '[ERROR]') {
        setMessages(prev => [...prev.slice(0, -1), {
          role: 'assistant',
          content: 'Lo siento, ocurrió un error. Por favor intenta nuevamente.',
        }]);
      } else {
        setMessages(prev => {
          const updated = [...prev];
          updated[updated.length - 1].content += data;
          return updated;
        });
      }
    });

    setIsLoading(false);
  };

  return {
    messages, input, setInput, isLoading, handleSendMessage, messagesEndRef,
  };
}
